module.exports = __webpack_public_path__ + "static/media/kw-left-bg.b72751cb.jpg";